import {
	Component,
	ContentChild,
	EventEmitter,
	Input,
	OnInit,
	Output,
	TemplateRef,
	ViewEncapsulation
} from '@angular/core';
import {DialogBase} from './dialog-base';

@Component({
	standalone: false,
	selector: 'im-dialog-area',
	template: `
		<ng-template #_maxLink_>
			<button dot-link
					(click)="resize()"
					[innerHTML]="dialog.maximize ?('' | act: 'defaultSize') : ('' | act:'maxSize')"
			></button>
		</ng-template>
		<ng-template #_closeLink_>
			<button dot-link
					(click)="close()"
					[innerHTML]="'' | act:'close'"
			></button>
		</ng-template>
		<article class="dialog">
			<header mat-dialog-title class="dialog-head" *ngIf="heading">
				<div dotRow class="dialog-head-area">
					<div class="dialog-headings">
						<h1 class="dialog-title" [innerHTML]="heading | nonKr"></h1>
						<p class="dialog-description" *ngIf="description | nonKr" [innerHTML]="description"></p>
					</div>
					<hr>
					@if (maximizable) {
						<ng-container *ngTemplateOutlet="_maxLink_"></ng-container>
					}
					<ng-container *ngTemplateOutlet="_closeLink_"></ng-container>
				</div>
			</header>

			<mat-dialog-content class="dialog-main" dotZone="modal">
				<div class="dialog-main-area">
					<ng-content></ng-content>
				</div>
			</mat-dialog-content>

			<mat-dialog-actions>
				<footer class="dialog-foot">
					<div class="dialog-foot-area" dotZone="modal">
						<ng-container *ngIf="_foot_; else _closeLink_">
							<ng-container *ngTemplateOutlet="_foot_"></ng-container>
						</ng-container>
					</div>
				</footer>
			</mat-dialog-actions>
		</article>
	`,
	styleUrls: ['./dialog-area.scss'],
	encapsulation: ViewEncapsulation.None
})
/**
 * 대화상자 영역 컴포넌트
 */
export class DialogAreaComponent implements OnInit {
	@Input() dialog!: DialogBase;

	@Input() heading!: string;
	@Input() description!: string;

	@Input() maximizable: boolean;
	@Input() maximize: boolean;

	@Output() resized$ = new EventEmitter<boolean>();

	@ContentChild('_foot_') _foot_!: TemplateRef<any>;

	ngOnInit() {
		if(this.maximize){
			this.resize();
		}
	}

	resize(){
		this.resized$.emit(
			this.dialog.resize()
		);
	}

	close() {
		this.dialog.close();
	}
}
